
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication",
      function () {
        return require("private-next-pages/authentication/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication"])
      });
    }
  